import { Tooltip } from "primereact/tooltip";
import { useHomeContext } from "../../contexts/HomeContext";
import Card from "../Card";
import CardLoader from "../CardLoader";
import Container from "../Container";
import Icon from "../Icon";
import Text from "../Text";

interface IRentabilityLabelProps {
    label: string;
    value: number;
}

const RentabilityLabel = ({ label, value }: IRentabilityLabelProps) => {
    return (
        <Container between>
            <Text color="800" fontWeight="medium">{label}</Text>

            <Container center gap={1}>
                <Text color="700">
                    {Math.round(value * 100) / 100}%
                </Text>

                {
                        value <= 0
                            ? <Icon name="pi-arrow-down" className="text-red-500" />
                            : <Icon name="pi-arrow-up" className="text-green-500" />
                }
            </Container>
        </Container>
    )
}

export default function RentabilityViewCard() {
    const homeContext = useHomeContext();

    return (
        <Card className="justify-content-start">
            {
                homeContext.isLoading
                    ? (
                        <CardLoader />
                    )
                    : (
                        <Container flexColumn fullWidth gap={3} className="flex-1" paddingVertical="3">
                            <Container className="justify-content-between align-items-center">
                                <Tooltip 
                                    target=".rentability-tooltip"
                                    content="Essa rentabilidade mostra o % de rendimentos dos ativos atuais de sua carteira, sem desconto de impostos ou inflação." 
                                />
                                <Text color="800" fontWeight="semibold">Rentabilidade Bruta Atual <Icon name="pi-info-circle" className="rentability-tooltip" size={2} /></Text>
                            </Container>

                            <Container flexColumn fullWidth className="flex-1 justify-content-center" gap={3}>
                                <RentabilityLabel label="Dia anterior" value={homeContext.portfolio?.actual_day ?? 0} />
                                <RentabilityLabel label="Mês" value={homeContext.portfolio?.actual_month ?? 0} />
                                <RentabilityLabel label="Últimos 12 meses" value={homeContext.portfolio?.last_12_month ?? 0} />
                                <RentabilityLabel label="Últimos 24 meses" value={homeContext.portfolio?.last_24_month ?? 0} />
                                <RentabilityLabel label="Desde o início" value={homeContext.portfolio?.from_start ?? 0} />
                            </Container>
                        </Container>
                    )
            }
        </Card>
    )
}
